<div class="container" *ngIf="preguntas != null">
  <div class="contenedor-datos-basicos">
    <div class="contenedor-title">
      <p class="title">Verificación de identidad</p>
      <p class="preguntas">Preguntas {{ paso + 1 }} / {{ preguntas.length }}</p>
    </div>
    <div *ngIf="preguntas != null" class="contenedor-preguntas">
      <p class="texto-pregunta">
        {{ preguntas[paso].descripcion }}
      </p>
      <div>
        <mat-radio-group aria-label="Select an option">
          <div class="radioB d-flex flex-column mt-3">
            <mat-radio-button
              class="w-100 respuesta my-2"
              *ngFor="let respuesta of preguntas[paso].respuestas"
              value="{{ respuesta.orden }}"
              (click)="
                seleccionarPregunta(preguntas[paso].orden, respuesta.orden)
              "
            >
              {{ respuesta.descripcion }}</mat-radio-button
            >
          </div>
        </mat-radio-group>
        <button
          class="btn btn-azul btn-redondo mt-3"
          type="button"
          *ngIf="this.paso + 1 >= preguntas.length"
          (click)="navegarAlert()"
        >
          Continuar
        </button>
        <button
          class="btn btn-azul btn-redondo mt-3"
          (click)="siguiente()"
          *ngIf="this.paso + 1 < preguntas.length"
          [disabled]="itemSelect"
        >
          Siguiente
        </button>
      </div>
    </div>
  </div>
</div>
